import { ImageDialogInput } from '@/main/image-dialog/image-dialog-input'
import { DialogResult } from '@/shared/dialog/dialog-result'
import { Injector } from '@/config/dependency-injection'
import { DialogService } from '@/shared/dialog/dialog-service'
import ImageDialog from '@/main/image-dialog/image-dialog.vue'
import { ImageDialogOutput } from '@/main/image-dialog/image-dialog-output'

export function imageDialog(properties: ImageDialogInput): DialogResult<ImageDialogOutput, void> {
  const dialogService = Injector.get(DialogService)

  return dialogService.openDynamic(ImageDialog, properties)
}
